(function () {
  class XTSFeaturedCollectionTabs extends HTMLElement {
    constructor() {
      super();
      this.onTabClick = this.onTabClick.bind(this);
      this.onTabsKeydown = this.onTabsKeydown.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
    }

    connectedCallback() {
      if (this.isInitialized) return;
      this.isInitialized = true;

      this.tabButtons = Array.from(this.querySelectorAll('[data-tab-button]'));
      this.tabPanels = Array.from(this.querySelectorAll('[data-tab-panel]'));
      this.buttonsById = new Map(this.tabButtons.map((button) => [button.dataset.tabId, button]));
      this.panelsById = new Map(this.tabPanels.map((panel) => [panel.dataset.blockId, panel]));

      if (this.tabButtons.length < 1 || this.tabPanels.length < 1) return;

      this.tabButtons.forEach((button) => button.addEventListener('click', this.onTabClick));
      this.addEventListener('keydown', this.onTabsKeydown);
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      const activeButton = this.tabButtons.find((button) => button.classList.contains('is-active')) || this.tabButtons[0];
      this.setActiveTab(activeButton.dataset.tabId, false);
    }

    disconnectedCallback() {
      if (!this.isInitialized) return;
      this.tabButtons.forEach((button) => button.removeEventListener('click', this.onTabClick));
      this.removeEventListener('keydown', this.onTabsKeydown);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    onTabClick(event) {
      const button = event.currentTarget;
      if (!button || !button.dataset.tabId) return;
      this.setActiveTab(button.dataset.tabId, true);
    }

    onTabsKeydown(event) {
      const activeElement = document.activeElement;
      if (!activeElement || !activeElement.matches('[data-tab-button]') || !this.contains(activeElement)) return;

      const currentIndex = this.tabButtons.indexOf(activeElement);
      if (currentIndex < 0) return;

      let targetIndex = currentIndex;

      if (event.key === 'ArrowRight') targetIndex = (currentIndex + 1) % this.tabButtons.length;
      if (event.key === 'ArrowLeft') targetIndex = (currentIndex - 1 + this.tabButtons.length) % this.tabButtons.length;
      if (event.key === 'Home') targetIndex = 0;
      if (event.key === 'End') targetIndex = this.tabButtons.length - 1;

      if (targetIndex === currentIndex) return;

      event.preventDefault();
      const targetButton = this.tabButtons[targetIndex];
      this.setActiveTab(targetButton.dataset.tabId, false);
      targetButton.focus();
    }

    onBlockSelect(event) {
      const selectedPanel = event.target.closest('[data-block-id]');
      if (!selectedPanel || !this.contains(selectedPanel)) return;

      const tabId = selectedPanel.dataset.blockId;
      if (!tabId) return;

      this.setActiveTab(tabId, false);
      const linkedButton = this.buttonsById.get(tabId);
      if (linkedButton) linkedButton.focus();
    }

    setActiveTab(tabId, resetSliderPosition) {
      const targetButton = this.buttonsById.get(tabId) || this.tabButtons[0];
      if (!targetButton) return;

      const targetId = targetButton.dataset.tabId;

      this.tabButtons.forEach((button) => {
        const isActive = button.dataset.tabId === targetId;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.tabPanels.forEach((panel) => {
        const isActive = panel.dataset.blockId === targetId;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      const activePanel = this.panelsById.get(targetId);
      if (!activePanel) return;

      requestAnimationFrame(() => {
        const slider = activePanel.querySelector('slider-component');
        if (!slider) return;

        if (typeof slider.xtsContainedCarouselRefresh === 'function') {
          slider.xtsContainedCarouselRefresh(resetSliderPosition);
          return;
        }

        if (!slider.slider) return;

        if (resetSliderPosition) {
          slider.slider.scrollTo({ left: 0, behavior: 'auto' });
        }

        if (typeof slider.initPages === 'function') slider.initPages();
        if (typeof slider.update === 'function') slider.update();
      });
    }
  }

  if (!customElements.get('xts-featured-collection-tabs')) {
    customElements.define('xts-featured-collection-tabs', XTSFeaturedCollectionTabs);
  }
})();
